<lib-report-buttons
  [formats]="formats"
  (generateReport)="generateReport()"
  (downloadReport)="downloadReport($event)"></lib-report-buttons>
